import { DEFAULT_LOCATION } from '../../constants/defaultLocation';
import * as constants from './constants';

const INITIAL_STATE = {
  province: DEFAULT_LOCATION.provinceName,
  isocode: DEFAULT_LOCATION.provinceIsocode,
  city: DEFAULT_LOCATION.cityName,
  allCity: [],
  cityIso: DEFAULT_LOCATION.cityIsocode,
};

const exportedObject = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case constants.SET_GEO_LOCATION_VALUE:
      return Object.assign({}, state, {
        province: action.payload.province,
        isocode: action.payload.isocode,
        city: action.payload.city,
        allCity: action.payload.allCity,
        cityIso: action.payload.cityIso,
      });
    default:
      return state;
  }
};

export default exportedObject;
